import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "big_square_check_icon--sprite",
  "use": "big_square_check_icon--sprite-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"big_square_check_icon--sprite\">\n    <rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#4A90E2\" />\n    <path d=\"M36.2551 16.4192L19.0739 33.6004L11.1992 25.7257L13.218 23.7069L19.0739 29.5485L34.2364 14.4004L36.2551 16.4192Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol